// After "Connect VPN" (D80): run the relay command, then sign in; the panel above watches the
// state come up. The callback URL is this page's own origin plus the one-time path.
import { ArrowSquareOut, DeviceMobile } from "@phosphor-icons/react";

import { useT } from "../i18n";
import type { VpnLogin } from "./api";
import { CopyBlock } from "./CopyBlock";
import { callbackUrl, ncCommand, pythonCommand } from "./relay";

export function ConnectSteps({ login, origin }: { login: VpnLogin; origin: string }) {
  const t = useT().vpn.connect;
  const url = callbackUrl(origin, login.callback_path);
  const until = new Date(login.code_expires_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return (
    <div className="space-y-4">
      <p className="m-0 flex items-start gap-2 rounded-lg border border-muted bg-gray-50 p-3 text-[13px] text-gray-700 dark:bg-gray-100">
        <DeviceMobile weight="duotone" className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
        <span>{t.phoneHint}</span>
      </p>
      <div className="space-y-2">
        <p className="m-0 text-sm text-gray-800">{t.step1}</p>
        <CopyBlock text={ncCommand(url)} label="nc" />
        <details className="text-[13px] text-gray-600">
          <summary className="cursor-pointer">{t.alternative}</summary>
          <div className="mt-2">
            <CopyBlock text={pythonCommand(url)} label="python3" />
          </div>
        </details>
      </div>
      <div className="space-y-2">
        <p className="m-0 text-sm text-gray-800">{t.step2}</p>
        <a
          href={login.idp_url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-dark"
        >
          {t.signIn} <ArrowSquareOut className="h-4 w-4" />
        </a>
        <p className="m-0 text-[12.5px] text-gray-500">{t.expires(until)}</p>
      </div>
    </div>
  );
}
